<div class="modal-backdrop" (click)="closeDialog()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">{{ isEditMode ? 'Editar Endereço' : 'Adicionar Endereço' }}</h3>
    </div>

    <div class="modal-body">
      <form [formGroup]="addressForm">
        <!-- CEP -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>CEP</mat-label>
          <input matInput formControlName="zipCode" placeholder="00000-000" maxlength="9"
            (input)="formatarCep($event)" required />
          <mat-spinner matSuffix diameter="20" *ngIf="isLoadingCep"></mat-spinner>
          <mat-hint align="start" class="text-secondary">Digite o CEP para preenchimento automático</mat-hint>
          <mat-error *ngIf="addressForm.get('zipCode')?.hasError('required')">CEP é obrigatório</mat-error>
          <mat-error *ngIf="addressForm.get('zipCode')?.hasError('pattern')">CEP inválido</mat-error>
        </mat-form-field>

        <!-- Estado e Cidade -->
        <div class="form-row mb-md">
          <mat-form-field appearance="outline" floatLabel="always" class="form-col">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="state" required (selectionChange)="onStateChange($event)">
              <mat-option *ngFor="let estado of estados" [value]="estado.sigla">
                {{ estado.nome }} ({{ estado.sigla }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="form-col">
            <mat-label>Cidade</mat-label>
            <mat-select formControlName="city" required>
              <mat-option *ngFor="let cidade of cidades" [value]="cidade.nome">
                {{ cidade.nome }}
              </mat-option>
            </mat-select>
            <mat-spinner matSuffix diameter="20" *ngIf="isLoadingCities"></mat-spinner>
          </mat-form-field>
        </div>

        <!-- Bairro -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="district" required />
        </mat-form-field>

        <!-- Rua -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>Rua</mat-label>
          <input matInput formControlName="street" required />
        </mat-form-field>

        <!-- Número e Complemento -->
        <div class="form-row mb-md">
          <mat-form-field appearance="outline" floatLabel="always" class="form-col">
            <mat-label>Número</mat-label>
            <input id="numero" matInput formControlName="number" required />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="form-col">
            <mat-label>Complemento</mat-label>
            <input matInput formControlName="complement" />
          </mat-form-field>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-ghost" type="button" (click)="closeDialog()">Cancelar</button>
      <button class="btn btn-primary" type="button" (click)="createAddress()" [disabled]="!addressForm.valid">
        {{ isEditMode ? 'Salvar Endereço' : 'Adicionar Endereço' }}
      </button>
    </div>
  </div>
</div>